<script>
    import { onMount } from 'svelte';
    import { link } from "svelte-routing";
    import { appSettings, personen, orte } from "../stores";
    import Swiper from "../components/swiper/Swiper.svelte";
    import SwiperSlide from "../components/swiper/SwiperSlide.svelte";
    import Thumbnail from "../components/Thumbnail.svelte";

    onMount ( () => {
        $appSettings.currentPageLink = "/";
        $appSettings.currentPageName = "Startseite";
        $appSettings.parentPage = "/";
        $appSettings.personIndex = $appSettings.personIndex??Math.floor(Math.random() * personen.length);
        $appSettings.ortIndex = $appSettings.ortIndex??Math.floor(Math.random() * orte.length);
        window.scrollTo(0, 0);
})
</script>

<div class="hero-img">
</div>

<section>
    <h1>27. Januar</h1>
    <p>Der 27. Januar ist 2005 zum <strong>Internationalen Tag des Gedenkens an die Opfer des Nationalsozialismus</strong> erklärt worden. 60 Jahre zuvor – am 27. Januar 1945 – wurde das Konzentrations- und Vernichtungslager Auschwitz-Birkenau befreit.</p>
    <p>In mahnender Erinnerung wird auch in Trier seit Jahren allen Opfern des Nationalsozialismus gedacht. In diesem Jahr widmet sich das Projekt <strong>Erinnerlicht</strong> explizit den jüdischen Opfern der Stadt Trier und dem Umland. Knapp 650 Bürgerinnen und Bürger wurden zwischen Oktober 1941 und März 1943 von Trier aus in Ghettos, Konzentrations- und Vernichtungslager deportiert. Von diesen haben nur 29 die Shoah überlebt.</p>
</section>

<section>
    <a href="/personen" use:link>
        <h2>Deportiert aus Trier</h2>
        <span>Mehr erfahren</span>
    </a>
    <div class="gallery">
        <Swiper bind:activeSlide={$appSettings.personIndex}>
            {#each personen as person}
            <SwiperSlide>
                <Thumbnail url={"/personen/"+person.id} title={person.name} img_url={"/personen/"+person.title_img} aspectRatio={60}/>
            </SwiperSlide>
            {/each}
        </Swiper>
    </div>
</section>

<section>
    <a href="/orte" use:link>
        <h2>Orte der Deportationen</h2>
        <span>Mehr erfahren</span>
    </a>
    <!-- <h2>Orte der Deportationen</h2>
    <a href="/orte" use:link>Mehr erfahren »</a> -->
    <div class="gallery">
        <Swiper bind:activeSlide={$appSettings.ortIndex}>
            {#each orte as ort}
            <SwiperSlide>
                <Thumbnail url={"/orte/"+ort.id} title={ort.street} img_url={"/orte/title_preview/"+ort.title_img} aspectRatio={60}/>
            </SwiperSlide>
            {/each}
        </Swiper>
    </div>
</section>

<style>
    .hero-img {
        height: 60vh;
        background-image: url("/images/bg/hero_home.jpg");
        background-position: bottom;
        background-repeat: no-repeat;
        background-size: cover;
        margin-top: -2rem;
        margin-left: -2rem;
        margin-right: -2rem;
        position: relative;
    }

    .hero-img::after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: linear-gradient(transparent 40%, #1a1a1a);
    }

    .gallery {
        margin-left: -2rem;
        margin-right: -2rem;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }

    h2 {
        margin-bottom: 0.25rem;
    }

    a {
        color: #FFFFFFA0;
        /* color: #fff4d1a0; */
        font-size: 1.1rem;
        /* text-decoration: underline; */
        /* text-underline-offset: 0.1em; */
        font-weight: 300;
    }

    a:hover {
        text-decoration: none;
    }
/* 
    a>span {
        position: relative;
    } */

    a:hover>span {
        color: white;
        /* text-decoration: underline; */
    }

    a>span::after{
        content: '»';
        display: inline-block;
        padding-inline-start: 0.5rem;
        transform: translateX(0);
        transition: transform 0.3s;
    }

    a:hover>span::after{
        transform: translateX(5px);
        color: white;
    }
</style>